<template>
  <v-app dark>
    <BibliomapHybrid />
  </v-app>
</template>

<script>
import BibliomapHybrid from './components/BibliomapHybrid.vue'

export default {
  name: 'app',
  components: {
    BibliomapHybrid
  }
}
</script>

